import PROGRESS_UPDATE from '../actions/progress/actionTypes';

const defaultState = {
  progress: 0,
};

const progressReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${PROGRESS_UPDATE}`:
      return { ...state, progress: action.progress };
    default:
      return state;
  }
};

export default progressReducer;



// WEBPACK FOOTER //
// ./src/reducers/progress.js